import { DefaultState } from '@src/redux/types'

import {
  TEACHING_WORKLOAD_APPROVAL_ALL,
  TEACHING_WORKLOAD_APPROVAL_BY_ID,
  TEACHING_WORKLOAD_APPROVAL_RESPONSE,
  TEACHING_WORKLOAD_APPROVAL_SUBMIT,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [TEACHING_WORKLOAD_APPROVAL_ALL]: DefaultState<`${typeof API.TEACHING_WORKLOAD_APPROVAL_ALL}`, 'get'>
  [TEACHING_WORKLOAD_APPROVAL_BY_ID]: DefaultState<`${typeof API.TEACHING_WORKLOAD_APPROVAL_BY_ID}{id}`, 'get'>
  [TEACHING_WORKLOAD_APPROVAL_SUBMIT]: DefaultState<`${typeof API.TEACHING_WORKLOAD_APPROVAL_SUBMIT}`, 'post'>
  [TEACHING_WORKLOAD_APPROVAL_RESPONSE]: DefaultState<`${typeof API.TEACHING_WORKLOAD_APPROVAL_RESPONSE}`, 'post'>
} = () => ({
  [TEACHING_WORKLOAD_APPROVAL_ALL]: defaultState(),
  [TEACHING_WORKLOAD_APPROVAL_BY_ID]: defaultState(),
  [TEACHING_WORKLOAD_APPROVAL_SUBMIT]: defaultState(),
  [TEACHING_WORKLOAD_APPROVAL_RESPONSE]: defaultState(),
})
